import {
  IWorkflowTemplateListResponse,
  TWorkflowTemplateCategory,
} from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';

/** Published workflow templates assigned to the given company — what a client user may run.
 * An optional category narrows to that catalog bucket (metadata.category, server-side). */
export const useAvailableWorkflowTemplates = (
  companyId: number | null,
  category?: TWorkflowTemplateCategory
) => {
  const { data, error, isLoading, mutate } =
    useSWR<IWorkflowTemplateListResponse>(
      companyId
        ? `${BASE_URL}/available?companyId=${companyId}${
            category ? `&category=${category}` : ''
          }`
        : null,
      SWRFetcher({
        method: 'GET',
      })
    );

  return { data, error, isLoading, mutate };
};
